import { AppUser } from '../../../views/App/App';
import axios from 'Src/helpers/api/axiosInstance';
import {
  ProgrammeBookingInboxItem,
  ProgrammeBookingInvitesResponse,
  ProgrammeBookingPlayerDetails,
  ProgrammeBookingDraftPayload,
  ProgrammeBookingConfirmPayload
} from '../../../views/GenericView/components/ClubProgrammes/ProgrammeBooking/ProgrammeBooking.types';

export function getParentProgrammeBookingInbox(
  user: AppUser,
  schoolId: string,
  playerPermissionId?: string
): Promise<ProgrammeBookingInboxItem[]> {
  const { roleSessionKey: key } = user;

  const config = {
    headers: { usid: key },
    params: playerPermissionId ? { playerPermissionId } : undefined
  };

  return axios.get(`${window.apiBase}/i/children/schools/${schoolId}/clubs/programmes/inbox`, config).then(r => r.data);
}

export function getParentProgrammeBookingInvites(
  user: AppUser,
  programmeId: string,
  playerPermissionId: string
): Promise<ProgrammeBookingInvitesResponse> {
  const { roleSessionKey: key } = user;

  const config = {
    headers: { usid: key },
    params: { playerPermissionId }
  };

  return axios.get(`${window.apiBase}/i/children/programmes/${programmeId}/invites`, config).then(r => r.data);
}

export function draftParentProgrammeClubInvite(
  user: AppUser,
  programmeId: string,
  clubId: string,
  data: ProgrammeBookingDraftPayload
): Promise<any> {
  const { roleSessionKey: key } = user;

  const config = {
    headers: { usid: key }
  };

  return axios
    .post(`${window.apiBase}/i/children/programmes/${programmeId}/clubs/${clubId}/draft`, data, config)
    .then(r => r.data);
}

export function undraftParentProgrammeClubInvite(
  user: AppUser,
  programmeId: string,
  clubId: string,
  data: ProgrammeBookingConfirmPayload
): Promise<any> {
  const { roleSessionKey: key } = user;

  return axios
    .request({
      method: 'DELETE',
      url: `${window.apiBase}/i/children/programmes/${programmeId}/clubs/${clubId}/draft`,
      headers: { usid: key },
      data
    })
    .then(r => r.data);
}

export function confirmParentProgrammeBooking(
  user: AppUser,
  programmeId: string,
  data: ProgrammeBookingConfirmPayload
): Promise<{ accepted: any[]; removedDrafts: number }> {
  const { roleSessionKey: key } = user;

  const config = {
    headers: { usid: key }
  };

  return axios.post(`${window.apiBase}/i/children/programmes/${programmeId}/confirm`, data, config).then(r => r.data);
}

export function updateAcceptedParentProgrammeClubInvite(
  user: AppUser,
  programmeId: string,
  clubId: string,
  data: ProgrammeBookingDraftPayload
): Promise<any> {
  const { roleSessionKey: key } = user;

  return axios
    .put(`${window.apiBase}/i/children/programmes/${programmeId}/clubs/${clubId}/accepted`, data, {
      headers: {
        usid: key,
        'Content-Type': 'application/json'
      }
    })
    .then(r => r.data);
}

export function cancelParentProgrammeClubInvite(
  user: AppUser,
  programmeId: string,
  clubId: string,
  data: ProgrammeBookingConfirmPayload
): Promise<any> {
  const { roleSessionKey: key } = user;

  return axios
    .request({
      method: 'DELETE',
      url: `${window.apiBase}/i/children/programmes/${programmeId}/clubs/${clubId}/accepted`,
      headers: { usid: key },
      data
    })
    .then(r => r.data);
}
